import { FC } from 'react'
import CustomLabel from '../CustomLabel'
import CustomInput from '../CustomInput'
import { integerFormat } from '../../utils/formFormat'
import { maxLengthRule, requiredRule } from '../../utils/formRules'
import { TControls } from '../../../features/userInfoForm/types'

const BuildingNumber: FC<TControls> = ({ control }) => (
  <div>
    <CustomLabel label="Building Number"/>
    <CustomInput
      name="buildingNo"
      control={control}
      handleChange={integerFormat}
      rules={{
        maxLength: maxLengthRule(12)
      }}
    />
  </div>
)

export default BuildingNumber
